import JellowLogoUrl from '@/assets/jellow-logo.svg?url'
import JellowLogoPngUrl from '@/assets/jellow-logo.png?url'
import JikeLogoUrl from '@/assets/jike-logo.svg?url'
import JikeLogoPngUrl from '@/assets/jike-logo.png?url'
import { useIsDarkTheme } from '@/utils/hooks/useTheme'
import { useEffect } from 'react'

export default function FaviconService() {
	const isDarkTheme = useIsDarkTheme()
	const faviconUrl = isDarkTheme ? JellowLogoUrl : JikeLogoUrl
	const faviconPngUrl = isDarkTheme ? JellowLogoPngUrl : JikeLogoPngUrl

	useEffect(() => {
		const favicon = document.querySelector<HTMLLinkElement>('#favicon')
		const faviconPng = document.querySelector<HTMLLinkElement>('#favicon-png')
		if (!favicon || !faviconPng) {
			return
		}

		favicon.href = faviconUrl
		favicon.type = 'image/svg+xml'
		faviconPng.href = faviconPngUrl
		faviconPng.type = 'image/png'
	}, [faviconPngUrl, faviconUrl])

	return null
}
